import PropTypes from 'prop-types';
import { Form, Button, Card, Row, Col, ProgressBar } from 'react-bootstrap';

function hogaresCumplenViviendaControl() {
    const tdtotcanthogcumplenviv = document.getElementById('tdtotcanthogcumplenviv').textContent;
    alert(`Cantidad de hogares que cumplen con requisitos para una vivienda digna: ${tdtotcanthogcumplenviv}`);
}
function hogaresNoCumplenViviendaControl() {
    const tdtotcanthognocumplenviv = document.getElementById('tdtotcanthognocumplenviv').textContent;
    alert(`Cantidad de hogares que no cumplen con requisitos para una vivienda digna: ${tdtotcanthognocumplenviv}`);
}
function ReporteVivienda({ dataVivienda }) {
    return (
        <Card classNameName="mb-4">
            <Card.Header>
                <h3>Derecho a la Vivienda</h3>
            </Card.Header>
            <Card.Body>
                <div className="row">
                    <div className="col-md-8">
                        <div className="box">
                        <div className="box-header">
                            <h3 className="box-title">Derecho a la Vivienda</h3>
                        </div>
                        <div className="box-body no-padding">
                            <table className="table table-condensed">
                                <thead>
                                    <tr>
                                        <th style={{backgroundColor: '#F0F1EF'}}></th>
                                        <th style={{backgroundColor: '#F0F1EF'}}>Cantidad</th>
                                        <th style={{backgroundColor: '#F0F1EF'}}>Porcentaje</th>
                                    </tr>
                                </thead>
                                <tbody>
                                
                                <tr>
                                    <td>Total hogares</td>
                                    <td className="thdcenter"><span id="tdcanthogaresviv">{dataVivienda.tdcanthogaresviv}</span></td>
                                    <td className="thdcenter"><span id="tdporccanthogaresviv" className="badge bg-blue">{dataVivienda.tdporccanthogaresviv}</span></td>  
                                </tr>
                                <tr>
                                    <td><button style={{color: 'green', cursor: 'pointer', background: 'none', border: 'none', padding: 0, textDecoration: 'underline'}} onClick={hogaresCumplenViviendaControl}>hogares cumplen con requisitos para una vivienda digna</button></td>
                                    <td className="thdcenter"><span id="tdtotcanthogcumplenviv">{dataVivienda.tdtotcanthogcumplenviv}</span></td>
                                    <td className="thdcenter"><span id="tdporccanthogcumplenviv" className="badge bg-green">{dataVivienda.tdporccanthogcumplenviv}</span></td>  
                                </tr>
                                <tr>
                                    <td><button style={{color: 'red', cursor: 'pointer', background: 'none', border: 'none', padding: 0, textDecoration: 'underline'}} onClick={hogaresNoCumplenViviendaControl}>hogares no cumplen con requisitos para una vivienda digna</button></td>
                                    <td className="thdcenter"><span id="tdcanthognocumplenviv">{dataVivienda.tdcanthognocumplenviv}</span></td>
                                    <td className="thdcenter"><span id="tdporccanthognocumplenviv" className="badge bg-red">{dataVivienda.tdporccanthognocumplenviv}</span></td>  
                                </tr>
                                </tbody>
                            </table>
                            <hr/>
                        </div>
                        </div>
                    </div>
                </div> 
            </Card.Body>
        </Card>
    );
}

ReporteVivienda.propTypes = {
    dataVivienda: PropTypes.object.isRequired,
};

export default ReporteVivienda;